import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useNotification } from '@ancert/aui-notification-context';
import { AUITabNavigation } from '@ancert/aui-tab';
import { useSession } from '../../context/session.context';
import { useLoading } from '../../context/loading.context';
import { useBackOffice } from '../../context/backOffice.context';
import ListadoAdmin from './ListadoAdmin';
import { getDenuncias } from '../../services/denuncias.service';
import Configuracion from './Configuracion';
import { ROL } from '../../lib/role.enum';
import GestionUsuarios from './GestionUsuarios';
import { PERMISO_BACKOFFICE } from '../../constants/permission.constants';
import { ROUTES } from '../../constants';

const BackOffice = () => {
  const history = useHistory();
  const { activeTab, setActiveTab } = useBackOffice();
  const { openNotification } = useNotification();
  const { getUser } = useSession();
  const { role } = getUser();
  const { isLoading, setIsLoading } = useLoading();
  const [listadoData, setListadoData] = useState([]);

  const getData = async () => {
    const { status, data: result, error } = await getDenuncias();
    if (status === 200) {
      setListadoData(result);
      return;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error al recuperar los datos.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };

  const renderContent = () => {
    if (activeTab === 0) {
      return <ListadoAdmin data={listadoData} reload={getData} />;
    }
    if (activeTab === 1) {
      return <GestionUsuarios />;
    }
    if (activeTab === 2) {
      return <Configuracion />;
    }
    return <div />;
  };

  const handleClick = (e) => {
    setActiveTab(e.index);
  };

  useEffect(() => {
    if (!PERMISO_BACKOFFICE.some((user) => user === role)) {
      history.push(ROUTES.HOME);
    }
    setIsLoading(true);
    getData();
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return null;
  }
  return (
    <div className="o-sii-main-container">
      {role === ROL.ADMINISTRADOR && (
        <AUITabNavigation
          onTabChange={handleClick}
          activeTab={activeTab}
          tabs={[
            {
              header: 'Listado',
            },
            {
              header: 'Gestión de usuarios',
            },
            {
              header: 'Configuración',
            },
          ]}
        />
      )}
      {renderContent()}
    </div>
  );
};

BackOffice.propTypes = {};

export default BackOffice;
